import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { CalendarViews } from '../../../../calendar-types';
import { faClock } from '@fortawesome/pro-regular-svg-icons';
import { DragPart } from '../../interaction/movement/drag-and-resize/drag-part';
import { ITimeBlockComponentItem } from '../../types/time-block-component-item-types';

@Component({
  selector: 'app-time-block-body',
  templateUrl: './time-block-body.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeBlockBodyComponent implements AfterViewInit {
  @ViewChild('timeBlockBody') public timeBlockBody: ElementRef<HTMLElement>;
  @Input() public calendarViewMode: CalendarViews;
  @Input() public timeBlockComponentItem: ITimeBlockComponentItem;
  @Output() readonly timeBlockBodySet$ = new EventEmitter<ElementRef<HTMLElement>>();
  public readonly faClock = faClock;
  public readonly CalendarView = CalendarViews;
  public readonly DragPart = DragPart;

  ngAfterViewInit(): void {
    this.timeBlockBodySet$.next(this.timeBlockBody);
  }
}
